import PublicRouter from './PublicRouter';

function RootRouter() {
  return <PublicRouter />;
}

export default RootRouter;
